import { useTranslation } from 'react-i18next'
import useInitialDamageTypeFields from './useInitialDamageTypeFields'

const useDamageInitialData = (
  tabValue: number,
  damageData: { photoUrls?: string[] },
  currentSlide: number
) => {
  const { t } = useTranslation()

  const getDetailsTitleByValue = (value: number) => {
    switch (value) {
      case 0:
        return `${t('damage.inside')}`
      case 1:
        return `${t('damage.front')}`
      case 2:
        return `${t('damage.left')}`
      case 3:
        return `${t('damage.rear')}`
      default:
        return `${t('damage.right')}`
    }
  }

  const damageTypes = useInitialDamageTypeFields(tabValue)

  let damageDetailsTitle = getDetailsTitleByValue(tabValue)

  if (damageData?.photoUrls?.length > 1) {
    damageDetailsTitle += ` (${currentSlide}/${damageData?.photoUrls?.length})`
  }

  return {
    damageTypes,
    damageDetailsTitle,
  }
}

export default useDamageInitialData
